import { Link } from 'react-router-dom'
import { useTheme } from '../../contexts/ThemeContext'

interface AuthButtonsProps {
  variant?: 'desktop' | 'mobile'
  onLinkClick?: () => void
}

export default function AuthButtons({ variant = 'desktop', onLinkClick }: AuthButtonsProps) {
  const { theme } = useTheme()

  if (variant === 'mobile') {
    return (
      <div className="flex flex-col gap-3 pt-3 pb-4">
        <Link
          to="/login"
          onClick={onLinkClick}
          className={`w-full py-3 px-4 text-center font-semibold transition-all duration-300 active:scale-95 rounded-lg border border-gold-500/30 ${theme === 'dark'
              ? 'text-gold-400 hover:text-gold-300 hover:bg-gold-900/20 active:bg-gold-900/30'
              : 'text-gray-700 hover:text-gray-900 hover:bg-gold-400/20 active:bg-gold-400/30'
            }`}
        >
          Đăng Nhập
        </Link>
        <Link
          to="/register"
          onClick={onLinkClick}
          className="w-full py-3 px-4 text-center bg-gold-gradient text-white font-bold rounded-lg hover:shadow-lg hover:shadow-gold-500/50 hover:scale-105 active:scale-95 transition-all duration-300"
        >
          Đăng Ký
        </Link>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1.5 xl:gap-2 ml-2 xl:ml-3 pl-2 xl:pl-3 border-l border-gold-500/30 flex-shrink-0">
      <Link
        to="/login"
        className={`px-3 xl:px-4 py-2 font-semibold text-sm xl:text-base transition-all duration-300 rounded-lg whitespace-nowrap ${theme === 'dark'
            ? 'text-gold-400 hover:text-gold-300 hover:bg-gold-900/20'
            : 'text-gray-700 hover:text-gray-900 hover:bg-gold-400/20'
          }`}
      >
        Đăng Nhập
      </Link>
      <Link
        to="/register"
        className="px-3 xl:px-4 py-2 bg-gold-gradient text-white font-bold text-sm xl:text-base rounded-lg hover:shadow-lg hover:shadow-gold-500/50 transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
      >
        Đăng Ký
      </Link>
    </div>
  )
}

